import { fechaCorta } from '../enlaces';
import type { FacturacionTenant } from '../api';

/**
 * Lo que se ve del estado de facturación, en sus dos formas.
 *
 * Al día no se muestra nada — un aviso que dice «todo bien» todos los días
 * entrena a la gente a ignorar esa zona de la pantalla, el mismo criterio que
 * ya se usa con el panel de anomalías.
 */

/** Banda de aviso para «gracia»: nada se corta todavía, pero hay una fecha. */
export function BandaFacturacion({ facturacion }: { facturacion: FacturacionTenant }) {
  if (facturacion.estado !== 'gracia') return null;
  return (
    <p className="banda aviso">
      <strong>Tu pago está pendiente.</strong> El servicio se corta el{' '}
      {facturacion.graciaHasta ? fechaCorta(facturacion.graciaHasta) : 'pronto'} si no se
      regulariza. Contacta a Voxcom para ponerte al día.
    </p>
  );
}

/** Pantalla completa para «suspendido»: reemplaza el contenido, no lo tapa. */
export function CuentaSuspendida() {
  return (
    <main className="una-columna">
      <div className="sin-datos suspendido">
        <p>
          <strong>El servicio está suspendido por falta de pago.</strong>
        </p>
        <p className="tenue">
          No se está recibiendo telemetría nueva ni se pueden consultar los datos existentes. Lo
          ya registrado no se elimina: vuelve a estar disponible apenas se regularice el pago.
        </p>
        <p className="tenue">Contacta a Voxcom para reactivar el servicio.</p>
      </div>
    </main>
  );
}
